export default __webpack_public_path__ + "img/d6c86a07511e860c34238bbc8277cb69.png";